import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface PatentOverviewResponse {
    overview: {
        patent_total_count: number;
    };
}

export interface PaperStatusResponse {
    total_number: number;
}

export interface DataCoverageApi {
    getPatentOverviewInfo(): Promise<PatentOverviewResponse>;
    getPaperStatus(): Promise<PaperStatusResponse>;
}

export const DataCoverageApi = Symbol('DataCoverageApi');

@injectable()
export class DataCoverageApiImpl extends PsHttpService implements DataCoverageApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/core-search-api/search/data-coverage`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    getPatentOverviewInfo() {
        return this.get<PatSnapCommonResponseData<PatentOverviewResponse>>({
            url: '/getOverviewInfo',
        }).then((res) => {
            return res.data as PatentOverviewResponse;
        });
    }

    getPaperStatus() {
        return this.get<PatSnapCommonResponseData<PaperStatusResponse>>({
            url: 'paper-status',
        }).then((res) => {
            return res.data as PaperStatusResponse;
        });
    }
}
